import React, { ChangeEvent, FC, MouseEvent } from "react";
import { faStopwatch } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./_delay.scss";

type DelayProps = {
  onChange: ({ delay, applyAll }: { delay: number; applyAll: boolean }) => void;
  value: number;
  onClick: (event: MouseEvent) => void;
};

const Delay: FC<DelayProps> = (props) => {
  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    props.onChange({
      delay: parseInt(e.currentTarget.value || "0", 10),
      applyAll: false,
    });
  };

  return (
    <div className="inline-block">
      <FontAwesomeIcon icon={faStopwatch} />{" "}
      <input
        className="rounded-md w-12 shadow-inner p-1 border border-gray-400"
        value={props.value}
        onChange={onChange}
        onClick={props.onClick}
        maxLength={5}
      />{" "}
      ms
    </div>
  );
};

export default Delay;
